import React, {ForwardedRef, forwardRef, useImperativeHandle, useRef} from "react"
import GUI from "../GUI"
import Transition, { ITransition, TTransitionProps, TTransitionTypes } from "../Transition/Transition"
import { TAnchorProps } from "./AnchoredBackdrop"

export type TOverlayProps = Omit<React.ComponentPropsWithoutRef<"div">, "width"> & TTransitionProps & {
    modal?:boolean
    backdropClass?:string
    backdropTransition?:TTransitionTypes
    anchor?:TAnchorProps
    canDismiss?:(e:PointerEvent) => boolean
    onDismissed?:Function                       // called back backdrop when it's destroyed
}

export type TManagedOverlayProps = TOverlayProps & {
    open:boolean
}

export interface IOverlay {
    target:HTMLDivElement|null
}

function Overlay(props:TManagedOverlayProps, ref:ForwardedRef<IOverlay|null>) {
    const {className,transition,open,children,modal,canDismiss,backdropTransition,anchor,onDismissed,backdropClass,...divProps} = props
    const refSelf = useRef<ITransition|null>(null)

    useImperativeHandle(ref, () => ({
        get target() { return refSelf.current?.target || null }
    }), [])

    return <Transition ref={refSelf} className={GUI.joinClass("overlay", className)} {...divProps} transition={transition||"fade"}>{open?children:null}</Transition>
}

export default forwardRef(Overlay)
